import React, { Component } from 'react'

// lib
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import { Col, Row } from 'antd'

// redux
import { connect } from 'react-redux'
import appActions from '../../redux/app/actions'

class PageLinkComponent extends Component {
    _handleOpenPage = (openkey, key) => {
        this.props.changeOpenKeys([openkey])
        this.props.changeCurrent(key)
    }
    getRandomInt = px => {
        return Math.floor(Math.random() * Math.floor(px)) + 400
    }

    render() {
        const { page } = this.props
        return (
            <Col className="PageLinkCol" lg={6} md={12} xs={24} sm={12}>
                <Link
                    to={page.url}
                    onClick={() => this._handleOpenPage(page.openkey, page.key)}
                >
                    <Row
                        className="PageLink"
                        style={{
                            backgroundPosition: 'right left',
                            backgroundSize: this.getRandomInt(500),
                            backgroundImage: `url(${require('../../resource/image/blur-bg.jpg')}`,
                        }}
                    >
                        <Col md={6} lg={6} xs={6} xl={6}>
                            <div className="Img">
                                <img
                                    style={{ objectFit: 'cover' }}
                                    src={page.image ? page.image : ''}
                                    alt="image"
                                />
                            </div>
                        </Col>
                        <Col
                            md={18}
                            lg={18}
                            xs={18}
                            xl={18}
                            className="Content"
                            style={{ color: 'white' }}
                        >
                            <FormattedMessage id={page.id} />
                        </Col>
                    </Row>
                </Link>
            </Col>
        )
    }
}

const mapStateToProps = state => {
    return {}
}

const mapDispatchToProps = dispatch => {
    return {
        changeCurrent: key => {
            dispatch(appActions.changeCurrent(key))
        },
        changeOpenKeys: key => {
            dispatch(appActions.changeOpenKeys(key))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PageLinkComponent)
